// extracted by mini-css-extract-plugin
export default {"toggle":"toggle___13_EF","open":"open___2zCD3","main":"main___1BB7T"};